import React from "react";
import { useTranslation } from "react-i18next";

const LoginInnerContent = () => {
    const { t } = useTranslation("common");
    return (<>
        <div className="row g-2">
            <div className="col-md-4 d-flex">
                <div className="card w-100 login-inner-card">
                    <div className="card-body">
                        <p className="mb-0">{t('login.intro.contentOne')}</p>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex">
                <div className="card w-100 login-inner-card">
                    <div className="card-body">
                        <p className="mb-0">{t('login.intro.contentTwo')}</p>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex">
                <div className="card w-100 login-inner-card">
                    <div className="card-body">
                        <p className="mb-0">{t('login.intro.contentThree')}</p>
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default LoginInnerContent;